import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
// import Home from '@/views/Home.vue';
import HomeNew from "@/views/HomeNew.vue";
import { getRole, getToken } from "@/utils/cookie";
import { UserRole } from "@/resource/user/user.model";

// import Subjects from '@/views/Subjects.vue';
// import Subject from '@/views/Subject.vue';
// import Papers from '@/views/Papers.vue';
// import Paper from '@/views/Paper.vue';
// import PaperCreate from '@/views/PaperCreate.vue';
// import Collections from '@/views/Collections.vue';
// import Collection from '@/views/Collection.vue';
// import Profile from '@/views/Profile.vue';
// import AboutUs from '@/views/AboutUs.vue';
// import SigninPage from '@/views/SigninPage.vue';
// import SignupPage from '@/views/SignupPage.vue';
// import ResetPassword from '@/views/ResetPassword.vue';
// import AddQuestion from '@/views/AddQuestion.vue';
// import AdminQuestion from '@/views/AdminQuestion.vue';
// import UploadQuestions from '@/views/UploadQuestions.vue';
// import UploadQuestion from '@/views/UploadQuestion.vue';
// import AdminPreCollections from '@/views/AdminPreCollections.vue';
// import AdminPreCollection from '@/views/AdminPreCollection.vue';
// import PaperCollections from '@/views/PaperCollections.vue';
// import PaperCollection from '@/views/PaperCollection.vue';
// import Review from '@/views/Review.vue';
// import Dashboard from '@/views/Dashboard.vue';
// import AdminBlogs from '@/views/AdminBlogs.vue';
// import BlogEditor from '@/views/BlogEditor.vue';
// import Blogs from '@/views/Blogs.vue';
// import Blog from '@/views/Blog.vue';
// import TermsAndPrivacy from '@/views/Privacy.vue';
// import UpdatePhoneNumber from '@/views/UpdatePhoneNumber.vue';
// import Enterprise from '@/views/Enterprise.vue';
// import ComponentTest from '@/views/ComponentTest.vue';
// import Dashboard2 from '@/views/Dashboard2.vue';
// import QuestionEditor from '@/views/QuestionEditor.vue';
// import Pricing from '@/views/Pricing.vue';
// import PremiumSuccess from '@/views/PremiumSuccess.vue';
// import PremiumError from '@/views/PremiumError.vue';
// import PremiumCancel from '@/views/PremiumCancel.vue';
// import AdminQuestionMonitor from '@/views/AdminQuestionMonitor.vue';

Vue.use(VueRouter);

const Subjects = () =>
  import(/* webpackChunkName: "Subjects" */ "@/views/Subjects.vue");

const Subject = () =>
  import(/* webpackChunkName: "Subject" */ "@/views/Subject.vue");

const Papers = () =>
  import(/* webpackChunkName: "Papers" */ "@/views/Papers.vue");

const Paper = () => import(/* webpackChunkName: "Paper" */ "@/views/Paper.vue");

const PaperCreate = () =>
  import(/* webpackChunkName: "PaperCreate" */ "@/views/PaperCreate.vue");

const Collections = () =>
  import(/* webpackChunkName: "Collections" */ "@/views/Collections.vue");

const Collection = () =>
  import(/* webpackChunkName: "Collection" */ "@/views/Collection.vue");

const Profile = () =>
  import(/* webpackChunkName: "Profile" */ "@/views/Profile.vue");

const AboutUs = () =>
  import(/* webpackChunkName: "AboutUs" */ "@/views/AboutUs.vue");

const SigninPage = () =>
  import(/* webpackChunkName: "SigninPage" */ "@/views/SigninPage.vue");

const SignupPage = () =>
  import(/* webpackChunkName: "SignupPage" */ "@/views/SignupPage.vue");

const ResetPassword = () =>
  import(/* webpackChunkName: "ResetPassword" */ "@/views/ResetPassword.vue");

const AddQuestion = () =>
  import(/* webpackChunkName: "AddQuestion" */ "@/views/AddQuestion.vue");

const AdminQuestion = () =>
  import(/* webpackChunkName: "AdminQuestion" */ "@/views/AdminQuestion.vue");

const UploadQuestions = () =>
  import(
    /* webpackChunkName: "UploadQuestions" */ "@/views/UploadQuestions.vue"
  );

const UploadQuestion = () =>
  import(/* webpackChunkName: "UploadQuestion" */ "@/views/UploadQuestion.vue");

const AdminPreCollections = () =>
  import(
    /* webpackChunkName: "AdminPreCollections" */ "@/views/AdminPreCollections.vue"
  );

const AdminPreCollection = () =>
  import(
    /* webpackChunkName: "AdminPreCollection" */ "@/views/AdminPreCollection.vue"
  );

// const PaperCollections = () =>
//   import(
//     /* webpackChunkName: "PaperCollections" */ '@/views/PaperCollections.vue'
//   );

const PaperCollection = () =>
  import(
    /* webpackChunkName: "PaperCollection" */ "@/views/PaperCollection.vue"
  );

const Browse = () =>
  import(/* webpackChunkName: "Browse" */ "@/views/Browse.vue");

const FolderPage = () =>
  import(/* webpackChunkName: "FolderPage" */ "@/views/FolderPage.vue");

const Purchases = () =>
  import(/* webpackChunkName: "Purchases" */ "@/views/Purchases.vue");

const Review = () =>
  import(/* webpackChunkName: "Review" */ "@/views/Review.vue");

const Dashboard = () =>
  import(/* webpackChunkName: "Dashboard" */ "@/views/Dashboard.vue");

const AdminBlogs = () =>
  import(/* webpackChunkName: "AdminBlogs" */ "@/views/AdminBlogs.vue");

const BlogEditor = () =>
  import(/* webpackChunkName: "BlogEditor" */ "@/views/BlogEditor.vue");

const Blogs = () => import(/* webpackChunkName: "Blogs" */ "@/views/Blogs.vue");

const Blog = () => import(/* webpackChunkName: "Blog" */ "@/views/Blog.vue");

const TermsAndPrivacy = () =>
  import(/* webpackChunkName: "TermsAndPrivacy" */ "@/views/Privacy.vue");

const UpdatePhoneNumber = () =>
  import(
    /* webpackChunkName: "UpdatePhoneNumber" */ "@/views/UpdatePhoneNumber.vue"
  );

const Enterprise = () =>
  import(/* webpackChunkName: "Enterprise" */ "@/views/Enterprise.vue");

const Dashboard2 = () =>
  import(/* webpackChunkName: "Dashboard2" */ "@/views/Dashboard2.vue");

const QuestionEditor = () =>
  import(/* webpackChunkName: "QuestionEditor" */ "@/views/QuestionEditor.vue");

const Pricing = () =>
  import(/* webpackChunkName: "Pricing" */ "@/views/Pricing.vue");

// const Pricing2 = () =>
//   import(/* webpackChunkName: "Pricing2" */ '@/views/Pricing2.vue');

// const Pricing3 = () =>
//   import(/* webpackChunkName: "Pricing3" */ '@/views/Pricing3.vue');

// const Pricing4 = () =>
//   import(/* webpackChunkName: "Pricing4" */ '@/views/Pricing4.vue');

const PremiumSuccess = () =>
  import(/* webpackChunkName: "PremiumSuccess" */ "@/views/PremiumSuccess.vue");

const PremiumError = () =>
  import(/* webpackChunkName: "PremiumError" */ "@/views/PremiumError.vue");

const PremiumCancel = () =>
  import(/* webpackChunkName: "PremiumCancel" */ "@/views/PremiumCancel.vue");

const AdminQuestionMonitor = () =>
  import(
    /* webpackChunkName: "AdminQuestionMonitor" */ "@/views/AdminQuestionMonitor.vue"
  );

const AudioTest = () =>
  import(/* webpackChunkName: "AudioTest" */ "@/views/AudioTest.vue");

const StartExercises = () =>
  import(/* webpackChunkName: "StartExercises" */ "@/views/StartExercises.vue");

const AdminGeneratedPapers = () =>
  import(
    /* webpackChunkName: "AdminGeneratedPapers" */ "@/views/AdminGeneratedPapers.vue"
  );

const AdminGeneratedPaper = () =>
  import(
    /* webpackChunkName: "AdminGeneratedPaper" */ "@/views/AdminGeneratedPaper.vue"
  );

const Affiliate = () =>
  import(/* webpackChunkName: "Affiliate" */ "@/views/Affiliate.vue");

const GradePapers = () =>
  import(/* webpackChunkName: "GradePapers" */ "@/views/GradePapers.vue");

const GradePaper = () =>
  import(/* webpackChunkName: "GradePaper" */ "@/views/GradePaper.vue");

const GradePapersAdmin = () =>
  import(/* webpackChunkName: "GradePapers" */ "@/views/GradePapersAdmin.vue");

const CareerPath = () =>
  import(/* webpackChunkName: "CareerPath" */ "@/views/CareerPath.vue");

const NotFound = () =>
  import(/* webpackChunkName: "NotFound" */ "@/views/NotFound.vue");

const routes: RouteConfig[] = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: Home,
  // },
  {
    path: "/",
    name: "home",
    component: HomeNew,
  },
  {
    path: "/subjects",
    name: "subjects",
    component: Subjects,
  },
  {
    path: "/subjects/:uuid",
    name: "subject",
    component: Subject,
  },
  {
    path: "/subjects/:uuid/:type",
    name: "subject-with-type",
    component: Subject,
  },
  {
    path: "/papers",
    name: "papers",
    component: Papers,
  },
  {
    path: "/papers/create",
    name: "papers-create",
    component: PaperCreate,
  },
  {
    path: "/papers/:uuid",
    name: "paper",
    component: Paper,
  },
  {
    path: "/about-us",
    name: "about-us",
    component: AboutUs,
  },
  {
    path: "/join-us",
    name: "join-us",
    component: Enterprise,
  },
  {
    path: "/Pricing",
    name: "pricing",
    component: Pricing,
  },
  {
    path: "/a/:code",
    name: "pricing-affiliate",
    component: Pricing,
  },
  {
    path: "/program-affiliate",
    name: "program-affiliate",
    component: Affiliate,
  },
  // {
  //   path: '/promo-akhir-julai',
  //   name: 'campaign-2',
  //   component: Pricing2,
  // },
  // {
  //   path: '/modul-murah-mysoalan',
  //   name: 'campaign-3',
  //   component: Pricing3,
  // },
  // {
  //   path: '/promo-merdeka',
  //   name: 'campaign-4',
  //   component: Pricing4,
  // },
  {
    path: "/review-us",
    name: "review-us",
    component: Review,
  },
  {
    path: "/blog",
    name: "blog",
    component: Blogs,
  },
  {
    path: "/blog/:uuid",
    name: "blog-uuid",
    component: Blog,
  },
  {
    path: "/thank-you-for-your-subscription",
    name: "premium-sucess",
    component: PremiumSuccess,
  },
  {
    path: "/something-is-wrong-subscription",
    name: "premium-error",
    component: PremiumError,
  },
  {
    path: "/cancel-subscription",
    name: "premium-cancel",
    component: PremiumCancel,
  },
  // TODO: Remove this once done with new design implementation
  // {
  //   path: '/component-test',
  //   name: 'component-test',
  //   component: ComponentTest,
  // },
  {
    path: "/collections",
    name: "collections",
    component: Collections,
    meta: {
      private: true,
    },
  },
  {
    path: "/collections/:uuid",
    name: "collection",
    component: Collection,
    meta: {
      private: true,
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: {
      private: true,
    },
  },
  {
    path: "/profile/update-phone-number/:token",
    name: "update-phone-number",
    component: UpdatePhoneNumber,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/dashboard/subjects/:uuid",
    name: "dashboard-subject",
    component: AdminQuestionMonitor,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/admin-blogs",
    name: "admin-blogs",
    component: AdminBlogs,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/blog-editor",
    name: "blogeditor",
    component: BlogEditor,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/blog-editor/:uuid",
    name: "blogeditor-uuid",
    component: BlogEditor,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/add-question",
    name: "add-question",
    component: AddQuestion,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/question-editor",
    name: "question-editor",
    component: QuestionEditor,
    meta: {
      private: true,
    },
  },
  {
    path: "/new-dashboard",
    name: "new-dashboard",
    component: Dashboard2,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/admin-questions/:uuid",
    name: "admin-questions",
    component: AdminQuestion,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/upload-question",
    name: "upload-questions",
    component: UploadQuestions,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/pre-collections",
    name: "pre-collections",
    component: AdminPreCollections,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/pre-collection",
    name: "pre-collection",
    component: AdminPreCollection,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/pre-collection/:uuid",
    name: "pre-collection-uuid",
    component: AdminPreCollection,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/pdf-papers",
    name: "pdf-papers",
    redirect: "/browse",
  },
  {
    path: "/pdf-papers/:uuid",
    name: "pdf-paper",
    component: PaperCollection,
  },
  {
    path: "/pdf-papers/:uuid/:code",
    name: "pdf-paper-code",
    component: PaperCollection,
  },
  {
    path: "/browse",
    name: "browse",
    component: Browse,
  },
  {
    path: "/browse/:uuid",
    name: "browse-uuid",
    component: PaperCollection,
  },
  {
    path: "/browse/:uuid/:code",
    name: "browse-uuid-code",
    component: PaperCollection,
  },
  {
    path: "/folders/:uuid*",
    name: "folder",
    component: FolderPage,
  },
  {
    path: "/folders",
    name: "folders",
    component: FolderPage,
  },
  {
    path: "/purchases",
    name: "purchases",
    component: Purchases,
  },
  {
    path: "/collections/:uuid/start",
    name: "start-exercises",
    component: StartExercises,
  },
  {
    path: "/upload-question/:id",
    name: "upload-question",
    component: UploadQuestion,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/generated-papers",
    name: "generated-papers",
    component: AdminGeneratedPapers,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/generated-papers/:id",
    name: "generated-paper",
    component: AdminGeneratedPaper,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/auto-grades",
    name: "grade-papers",
    component: GradePapers,
    // meta: {
    //   private: true,
    //   admin: true,
    // },
  },
  {
    path: "/auto-grades/:uuid",
    name: "grade-paper",
    component: GradePaper,
    // meta: {
    //   private: true,
    //   admin: true,
    // },
  },
  {
    path: "/admin/auto-grades",
    name: "admin-grade-papers",
    component: GradePapersAdmin,
    meta: {
      private: true,
      admin: true,
    },
  },
  {
    path: "/signin",
    name: "signin",
    component: SigninPage,
    meta: {
      register: true,
    },
  },
  {
    path: "/signup",
    name: "signup",
    component: SignupPage,
    meta: {
      register: true,
    },
  },
  {
    path: "/amnesia",
    name: "amnesia",
    component: ResetPassword,
    meta: {
      register: true,
    },
  },
  {
    path: "/terms-and-privacy",
    name: "terms-and-privacy",
    component: TermsAndPrivacy,
  },
  {
    path: "/audio-test",
    name: "audio-test",
    component: AudioTest,
  },
  {
    path: "/get-me-career-path",
    name: "career-path",
    component: CareerPath,
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const token = getToken();
  const role = getRole();

  const roles = [UserRole.Admin, UserRole.SuperAdmin];
  if (!role || !roles.includes(role)) {
    // const app = router.app;
    // app.$sendMpEvent(app.$mp_event.PageView, '', { to: to.fullPath });
  }

  if (to.meta.register) {
    if (token) {
      if (from.name !== "home") {
        next({
          name: "home",
        });
      }
      return;
    } else {
      next();
    }
  } else {
    next();
  }

  if (to.meta.private) {
    if (token) {
      next();
    } else {
      next({
        name: "signin",
      });
    }
  } else {
    next();
  }

  if (to.meta.admin) {
    const roles = [UserRole.Admin, UserRole.SuperAdmin];
    if (role && roles.includes(role)) {
      next();
    } else {
      next({
        name: "home",
      });
    }
  } else {
    next();
  }
});

export default router;
